var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQueue2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 114,
    viewBox: "0 0 112 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91 0H21C9.40202 0 0 9.56991 0 21.375V92.625C0 104.43 9.40202 114 21 114H91C102.598 114 112 104.43 112 92.625V21.375C112 9.56991 102.598 0 91 0Z",
    fill: "#0AA0AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.659 55.552C30.7909 55.552 32.7115 54.2462 33.5277 52.2432C34.3441 50.2364 33.8959 47.9292 32.3871 46.3935C30.8784 44.8578 28.6116 44.4016 26.6401 45.2286C24.6722 46.0596 23.3858 48.018 23.3858 50.1881C23.3894 53.1482 25.7472 55.5483 28.659 55.552Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3967 48.0914C57.3967 52.0344 54.2589 55.2282 50.3888 55.2282C46.5185 55.2282 43.3809 52.0344 43.3809 48.0914C43.3809 44.152 46.5185 40.9582 50.3888 40.9582C54.2589 40.9582 57.3967 44.152 57.3967 48.0914Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5303 57.1095C72.23 57.1133 68.1084 58.853 65.0692 61.9503C62.0263 65.0439 60.3171 69.2393 60.3134 73.6162V80.2633H92.7514V73.6162C92.7477 69.2427 91.035 65.0438 87.9956 61.9503C84.9564 58.8568 80.8304 57.1133 76.5303 57.1095Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.1428 45.1985C67.1428 49.0674 69.4349 52.5579 72.948 54.038C76.4612 55.5217 80.5063 54.702 83.1953 51.9644C85.8849 49.227 86.6903 45.1094 85.2325 41.5341C83.7784 37.9545 80.3491 35.625 76.5446 35.625C71.3552 35.6287 67.1465 39.9126 67.1428 45.1985Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6708 57.8924C23.4703 57.8997 19.2575 62.1877 19.25 67.4814V71.0683H35.8057V70.0594C35.8094 67.8225 36.3123 65.6156 37.278 63.6088C35.7765 60.133 32.3988 57.8924 28.6708 57.8924Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.3946 57.5657C43.6163 57.577 38.1246 63.1669 38.1171 70.0624V74.9329H58.0184V73.6198V73.6235C58.0184 70.0737 59.0096 66.5979 60.8792 63.6004C58.6561 59.8652 54.6836 57.577 50.3946 57.5657Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_2",
    x: -32,
    y: -28,
    width: 176,
    height: 178,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_2",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 114,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQueue2);
export default __webpack_public_path__ + "static/media/queue2.5b4c88c3962f659eef2689dfc6e953cc.svg";
export { ForwardRef as ReactComponent };